(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-product-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = (pv) => {
      if (pv.dataset.nxBound) return;
      pv.dataset.nxBound = '1';
      const panels = [...pv.querySelectorAll('[data-nx-pv-panel]')];
      const thumbs = [...pv.querySelectorAll('[data-nx-pv-show]')];
      const back = pv.querySelector('.nx-pv__back');
      thumbs.forEach((t) => t.addEventListener('click', () => {
        const id = t.dataset.nxPvShow;
        panels.forEach((p) => (p.hidden = p.dataset.nxPvPanel !== id));
        thumbs.forEach((x) => {
          const on = x.dataset.nxPvShow === id && x !== back;
          x.classList.toggle('is-active', on);
          if (x !== back) x.setAttribute('aria-selected', String(on));
        });
        if (back) back.hidden = id === '3d';
        // The 3D view measures itself while visible; nudge it after it reappears.
        if (id === '3d') window.dispatchEvent(new Event('resize'));
      }));
      document.addEventListener('nx:color', (e) => {
        pv.dataset.color = String(e.detail || '').trim().toLowerCase();
      });
    };
    const start = () => document.querySelectorAll('[data-nx-pv]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-ring-3d-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    const DEG = Math.PI / 180;
    // Where each feature sits on the ring: angle around the band (deg) and side (inner = sensors).
    const ANCHORS = {
      heart: { angle: 0, inner: true, y: 0.12 },
      temperature: { angle: -55, inner: true, y: -0.1 },
      motion: { angle: 55, inner: true, y: 0.05 },
      shell: { angle: 150, inner: false, y: 0.3 },
      water: { angle: 200, inner: false, y: -0.3 },
      battery: { angle: -60, inner: true, y: 0.05 },
    };

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function webglAvailable() {
      try {
        const c = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
      } catch (e) {
        return false;
      }
    }

    async function init(root) {
      if (root.dataset.nxReady) return;
      root.dataset.nxReady = '1';

      const items = JSON.parse(root.querySelector('[data-nx-data]').textContent || '[]');
      const stage = root.querySelector('[data-nx-stage]');
      const canvas = root.querySelector('[data-nx-canvas]');
      const card = root.querySelector('[data-nx-card]');
      const buttons = [...root.querySelectorAll('[data-nx-hotspot]')];
      const exploreBtn = root.querySelector('[data-nx-explore]');

      const fail = () => {
        root.classList.add('nx-hero--no3d');
        if (exploreBtn) exploreBtn.hidden = true;
      };

      if (!webglAvailable() || items.length === 0) return fail();

      let THREE;
      try {
        THREE = await import(root.dataset.threeSrc);
      } catch (e) {
        return fail();
      }

      let renderer;
      try {
        renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'low-power' });
      } catch (e) {
        return fail();
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.outputColorSpace = THREE.SRGBColorSpace;

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 100);
      const HOME = new THREE.Vector3(0, 0.35, 7.2);
      camera.position.copy(HOME);

      // Studio environment for realistic metal reflections, generated in code (no image download).
      const envScene = new THREE.Scene();
      envScene.background = new THREE.Color(0x111018);
      const addPanel = (w, h, color, intensity, pos, rot) => {
        const m = new THREE.Mesh(
          new THREE.PlaneGeometry(w, h),
          new THREE.MeshBasicMaterial({ color: new THREE.Color(color).multiplyScalar(intensity), side: THREE.DoubleSide })
        );
        m.position.set(...pos);
        m.rotation.set(...rot);
        envScene.add(m);
      };
      addPanel(10, 3, 0xffffff, 3.2, [0, 6, 0], [Math.PI / 2, 0, 0]);
      addPanel(4, 8, 0xffffff, 1.6, [-7, 1, 2], [0, Math.PI / 2, 0]);
      addPanel(4, 8, 0x8b5cf6, 0.9, [7, 0, -1], [0, -Math.PI / 2, 0]);
      addPanel(12, 2, 0xffffff, 0.7, [0, -5, 0], [-Math.PI / 2, 0, 0]);
      const pmrem = new THREE.PMREMGenerator(renderer);
      scene.environment = pmrem.fromScene(envScene, 0.04).texture;

      // Ring band: lathe of a rounded-rectangle cross-section.
      const R_IN = 1.0;
      const R_OUT = 1.16;
      const HALF_H = 0.42;
      const profile = [];
      const r = 0.05;
      const corner = (cx, cy, a0) => {
        for (let i = 0; i <= 6; i++) {
          const a = (a0 + (i / 6) * 90) * DEG;
          profile.push(new THREE.Vector2(cx + Math.cos(a) * r, cy + Math.sin(a) * r));
        }
      };
      corner(R_IN + r, -HALF_H + r, 180);
      corner(R_OUT - r, -HALF_H + r, 270);
      corner(R_OUT - r, HALF_H - r, 0);
      corner(R_IN + r, HALF_H - r, 90);
      profile.push(profile[0].clone());
      const band = new THREE.LatheGeometry(profile, 160);

      const ring = new THREE.Group();
      const metal = new THREE.MeshPhysicalMaterial({ color: 0xd9dbe2, metalness: 1, roughness: 0.28, clearcoat: 0.6, clearcoatRoughness: 0.2 });
      ring.add(new THREE.Mesh(band, metal));

      // Brushed sparkle face on the outside (the R10 has a textured outer finish).
      const face = new THREE.Mesh(
        new THREE.CylinderGeometry(R_OUT + 0.002, R_OUT + 0.002, HALF_H * 1.3, 160, 1, true),
        new THREE.MeshPhysicalMaterial({ color: 0xc9ccd6, metalness: 0.9, roughness: 0.55, sheen: 1, sheenColor: 0xffffff })
      );
      ring.add(face);

      // Metal finishes. The home hero stays silver; the product viewer follows the colour picker.
      const METALS = {
        silver: { band: 0xd9dbe2, bandRough: 0.28, face: 0xc9ccd6, faceRough: 0.55, sheen: 0xffffff },
        black: { band: 0x5a5c66, bandRough: 0.22, face: 0x3b3d45, faceRough: 0.42, sheen: 0xb8b8c4 },
        gold: { band: 0xe6bd6a, bandRough: 0.24, face: 0xd2a457, faceRough: 0.5, sheen: 0xfff0c2 },
      };
      const setMetal = (name) => {
        const m = METALS[String(name || '').trim().toLowerCase()];
        if (!m) return;
        metal.color.setHex(m.band);
        metal.roughness = m.bandRough;
        face.material.color.setHex(m.face);
        face.material.roughness = m.faceRough;
        face.material.sheenColor.setHex(m.sheen);
      };
      setMetal(root.dataset.metal);
      if (root.hasAttribute('data-follow-color')) {
        document.addEventListener('nx:color', (e) => setMetal(e.detail));
      }

      // Dark inner shell with a faint purple glow, so the inside reads as electronics.
      const inner = new THREE.Mesh(
        new THREE.CylinderGeometry(R_IN - 0.004, R_IN - 0.004, HALF_H * 1.9, 160, 1, true),
        new THREE.MeshPhysicalMaterial({
          color: 0x14121c,
          metalness: 0.3,
          roughness: 0.22,
          clearcoat: 1,
          clearcoatRoughness: 0.1,
          emissive: 0x2a1650,
          emissiveIntensity: 0.55,
          side: THREE.BackSide,
        })
      );
      ring.add(inner);

      // Soft light inside the band: purple core plus green and cyan near the sensors.
      const core = new THREE.PointLight(0x8b5cf6, 2.2, 2.4, 1.6);
      ring.add(core);
      const sensorLight = (color, angleDeg, y, intensity) => {
        const l = new THREE.PointLight(color, intensity, 0.9, 2);
        const a = angleDeg * DEG;
        l.position.set(Math.cos(a) * (R_IN - 0.25), y, Math.sin(a) * (R_IN - 0.25));
        ring.add(l);
      };
      sensorLight(0x22ff99, 0, 0.1, 1.4);
      sensorLight(0x22e5ff, -55, -0.05, 1.1);

      // Additive halo used around the LEDs.
      const haloTex = (() => {
        const c = document.createElement('canvas');
        c.width = c.height = 64;
        const g = c.getContext('2d');
        const grad = g.createRadialGradient(32, 32, 0, 32, 32, 32);
        grad.addColorStop(0, 'rgba(255,255,255,1)');
        grad.addColorStop(0.35, 'rgba(255,255,255,0.35)');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = grad;
        g.fillRect(0, 0, 64, 64);
        return new THREE.CanvasTexture(c);
      })();
      const halo = (color, pos, size) => {
        const sp = new THREE.Sprite(
          new THREE.SpriteMaterial({ map: haloTex, color, transparent: true, blending: THREE.AdditiveBlending, depthWrite: false, opacity: 0.85 })
        );
        sp.position.copy(pos);
        sp.scale.set(size, size, size);
        ring.add(sp);
      };

      // Small sensor pads on the inside: cyan for temperature, green for motion.
      const pad = (color, angleDeg, y) => {
        const a = angleDeg * DEG;
        const m = new THREE.Mesh(
          new THREE.BoxGeometry(0.02, 0.07, 0.12),
          new THREE.MeshStandardMaterial({ color: 0x0b0b10, emissive: color, emissiveIntensity: 1.1, roughness: 0.3 })
        );
        m.position.set(Math.cos(a) * (R_IN - 0.012), y, Math.sin(a) * (R_IN - 0.012));
        m.rotation.y = -a;
        ring.add(m);
        halo(color, new THREE.Vector3(Math.cos(a) * (R_IN - 0.05), y, Math.sin(a) * (R_IN - 0.05)), 0.22);
      };
      pad(0x22e5ff, -55, -0.1);
      pad(0x22ff99, 55, 0.05);

      const sensorBase = new THREE.Mesh(
        new THREE.SphereGeometry(0.2, 32, 16, 0, Math.PI * 2, 0, Math.PI / 2),
        new THREE.MeshPhysicalMaterial({ color: 0x0c0c12, roughness: 0.15, transmission: 0.2, clearcoat: 1 })
      );
      sensorBase.scale.set(1.2, 0.28, 0.8);
      sensorBase.rotation.z = Math.PI / 2;
      sensorBase.position.set(R_IN - 0.01, 0.02, 0);
      ring.add(sensorBase);
      const led = (color, y, z) => {
        const m = new THREE.Mesh(
          new THREE.SphereGeometry(0.035, 16, 12),
          new THREE.MeshStandardMaterial({ color, emissive: color, emissiveIntensity: 2.4 })
        );
        m.position.set(R_IN - 0.05, y, z);
        ring.add(m);
        halo(color, new THREE.Vector3(R_IN - 0.08, y, z), 0.26);
      };
      led(0x22ff99, 0.12, 0.05);
      led(0x22ff99, 0.12, -0.05);
      led(0x22e5ff, -0.1, 0);

      ring.rotation.set(1.05, 0, 0.35);
      scene.add(ring);

      const anchorPoint = (key) => {
        const a = ANCHORS[key] || ANCHORS.shell;
        const rad = (a.inner ? R_IN - 0.04 : R_OUT + 0.02);
        const ang = a.angle * DEG;
        return {
          local: new THREE.Vector3(Math.cos(ang) * rad, a.y, Math.sin(ang) * rad),
          normal: new THREE.Vector3(Math.cos(ang) * (a.inner ? -1 : 1), 0, Math.sin(ang) * (a.inner ? -1 : 1)),
        };
      };
      const anchors = items.map((it) => anchorPoint(it.anchor));

      const resize = () => {
        const { width, height } = stage.getBoundingClientRect();
        if (!width || !height) return;
        renderer.setSize(width, height, false);
        camera.aspect = width / height;
        camera.fov = width < 600 ? 38 : 32;
        camera.updateProjectionMatrix();
      };
      resize();
      new ResizeObserver(resize).observe(stage);

      // State
      let active = -1;
      let spin = reduceMotion() ? 0 : 0.0035;
      let introT = reduceMotion() ? 1 : 0;
      const target = { rotX: 0.35, rotY: 0, rotZ: 0.18, cam: HOME.clone(), look: new THREE.Vector3() };
      const look = new THREE.Vector3();
      let dragging = false;
      let lastX = 0;
      let userYaw = 0;

      const tmp = new THREE.Vector3();
      const tmpN = new THREE.Vector3();

      function focus(i) {
        active = i;
        root.classList.toggle('nx-hero--focus', i >= 0);
        buttons.forEach((b, j) => b.classList.toggle('is-active', j === i));
        if (i < 0) {
          card.hidden = true;
          target.cam.copy(HOME);
          target.look.set(0, 0, 0);
          target.rotX = 0.35;
          target.rotZ = 0.18;
          spin = reduceMotion() ? 0 : 0.0035;
          return;
        }
        const it = items[i];
        card.querySelector('[data-nx-card-kicker]').textContent = it.kicker || '';
        card.querySelector('[data-nx-card-title]').textContent = it.title || '';
        card.querySelector('[data-nx-card-text]').textContent = it.text || '';
        card.hidden = false;
        spin = 0;
        // Turn the ring so the feature faces the camera, then move closer.
        // Inner features face the camera from the far side of the band; outer ones from the near side.
        const a = ANCHORS[it.anchor] || ANCHORS.shell;
        let wanted = (a.angle + (a.inner ? 90 : -90)) * DEG;
        const current = ring.rotation.y;
        wanted += Math.round((current - wanted) / (Math.PI * 2)) * Math.PI * 2;
        target.rotY = wanted;
        userYaw = 0;
        target.rotX = a.inner ? 1.0 : 0.2;
        target.rotZ = 0;
        // On desktop the card sits on the right, so shift the ring left.
        // In the compact product viewer the small card covers the bottom, so lift the ring instead.
        const narrow = stage.clientWidth < 600;
        if (root.classList.contains('nx-hero--embed')) {
          target.cam.set(0, 0.2, 6.2);
          target.look.set(0, -0.55, 0);
        } else {
          target.cam.set(0, 0.2, narrow ? 5.6 : 4.8);
          target.look.set(narrow ? 0 : 0.9, 0, 0);
        }
      }

      buttons.forEach((b, i) => b.addEventListener('click', () => focus(i)));
      card.querySelector('[data-nx-close]').addEventListener('click', () => {
        const i = active;
        focus(-1);
        buttons[i]?.focus();
      });
      card.querySelector('[data-nx-prev]').addEventListener('click', () => focus((active - 1 + items.length) % items.length));
      card.querySelector('[data-nx-next]').addEventListener('click', () => focus((active + 1) % items.length));
      root.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && active >= 0) focus(-1);
      });
      if (exploreBtn) {
        exploreBtn.addEventListener('click', () => {
          focus(0);
          stage.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
        });
      }

      // Drag to rotate (horizontal only, so page scroll keeps working on phones).
      stage.addEventListener('pointerdown', (e) => {
        if (e.target.closest('button')) return;
        dragging = true;
        lastX = e.clientX;
      });
      window.addEventListener('pointerup', () => (dragging = false));
      stage.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        userYaw += (e.clientX - lastX) * 0.01;
        lastX = e.clientX;
      });

      let visible = true;
      new IntersectionObserver(([entry]) => (visible = entry.isIntersecting)).observe(stage);

      root.classList.add('nx-hero--3d');

      const ease = (x) => 1 - Math.pow(1 - x, 3);
      let raf;
      let last = performance.now();
      function frame(now = performance.now()) {
        raf = requestAnimationFrame(frame);
        const dt = Math.min(0.1, (now - last) / 1000);
        last = now;
        if (!visible || document.hidden) return;

        // Frame-rate independent easing, so slow phones animate at the same speed.
        const k = reduceMotion() ? 1 : 1 - Math.pow(0.0065, dt);
        if (introT < 1) introT = Math.min(1, introT + dt / 1.0);
        const intro = ease(introT);

        target.rotY += spin * dt * 60;
        ring.rotation.x += (target.rotX * intro + 1.05 * (1 - intro) - ring.rotation.x) * k;
        ring.rotation.y += (target.rotY + userYaw + (1 - intro) * 1.2 - ring.rotation.y) * k;
        ring.rotation.z += (target.rotZ - ring.rotation.z) * k;
        ring.position.y = (1 - intro) * -0.2 + (reduceMotion() ? 0 : Math.sin(performance.now() / 1400) * 0.04);

        camera.position.lerp(target.cam, k);
        look.lerp(target.look, k);
        camera.lookAt(look);

        renderer.render(scene, camera);

        // Place hotspot buttons over their 3D points; hide those facing away.
        const { width, height } = stage.getBoundingClientRect();
        ring.updateMatrixWorld();
        anchors.forEach((an, i) => {
          tmp.copy(an.local).applyMatrix4(ring.matrixWorld);
          tmpN.copy(an.normal).transformDirection(ring.matrixWorld);
          const toCam = camera.position.clone().sub(tmp).normalize();
          const facing = tmpN.dot(toCam) > 0.15;
          tmp.project(camera);
          const x = (tmp.x * 0.5 + 0.5) * width;
          const y = (-tmp.y * 0.5 + 0.5) * height;
          const b = buttons[i];
          if (!b) return;
          b.style.transform = `translate(${x}px, ${y}px)`;
          // While a feature is open only its dot stays, so the view is not cluttered.
          const show = intro > 0.95 && (active < 0 ? facing : i === active);
          b.classList.toggle('is-visible', show);
          b.tabIndex = show ? 0 : -1;
        });
      }
      frame();

      document.addEventListener('shopify:section:unload', (e) => {
        if (e.target.contains(root)) {
          cancelAnimationFrame(raf);
          renderer.dispose();
        }
      });
    }

    // The hero is the first thing on the page, so start right away (no lazy wait).
    const start = () => document.querySelectorAll('.nx-hero').forEach((el) => init(el));

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    // Upper limit of each size, from the manufacturer chart: around the finger (mm) and inside diameter (mm).
    const SIZES = [
      { size: '7', finger: 57.4, ring: 17.9 },
      { size: '8', finger: 60.0, ring: 18.7 },
      { size: '9', finger: 62.7, ring: 19.6 },
      { size: '10', finger: 65.3, ring: 20.45 },
      { size: '11', finger: 67.7, ring: 21.2 },
      { size: '12', finger: 70.3, ring: 22.0 },
      { size: '13', finger: 73.0, ring: 22.8 },
    ];
    const MIN = { finger: 53.5, ring: 17.0 };

    const bind = (dialog) => {
      if (dialog.dataset.nxBound) return;
      dialog.dataset.nxBound = '1';
      const input = dialog.querySelector('[data-nx-sg-mm]');
      const result = dialog.querySelector('[data-nx-sg-result]');
      const sizeEl = dialog.querySelector('[data-nx-sg-size]');
      const caption = dialog.querySelector('[data-nx-sg-caption]');
      const chips = [...dialog.querySelectorAll('[data-nx-sg-scale] li')];
      const tabs = [...dialog.querySelectorAll('[data-nx-sg-mode]')];
      const use = dialog.querySelector('[data-nx-sg-use]');
      let match = null;

      const update = () => {
        const mode = dialog.dataset.mode;
        const mm = parseFloat(String(input.value).replace(',', '.'));
        match = mm && mm >= MIN[mode] ? SIZES.find((s) => mm <= s[mode]) || null : null;
        chips.forEach((c) => {
          c.classList.toggle('is-match', !!match && c.dataset.size === match.size);
          const label = c.querySelector('span');
          label.textContent = label.dataset[mode];
        });
        result.classList.toggle('is-match', !!match);
        sizeEl.textContent = match ? match.size : '–';
        caption.textContent = !input.value ? 'Your size' : match ? 'Your size' : 'Outside sizes 7–13';
        use.disabled = !match;
        use.textContent = match ? `Use size ${match.size}` : 'Use this size';
      };

      tabs.forEach((t) => t.addEventListener('click', () => {
        dialog.dataset.mode = t.dataset.nxSgMode;
        tabs.forEach((x) => {
          x.classList.toggle('is-on', x === t);
          x.setAttribute('aria-checked', String(x === t));
        });
        input.value = '';
        update();
        input.focus();
      }));
      input.addEventListener('input', update);

      use.addEventListener('click', () => {
        if (!match) return;
        const radio = [...document.querySelectorAll('[data-nx-pick] input[type="radio"]')]
          .find((r) => /size/i.test(r.name) && r.value === match.size);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          dialog.close();
          return;
        }
        const url = dialog.dataset.productUrl;
        if (url) window.location.href = `${url}${url.includes('?') ? '&' : '?'}size=${encodeURIComponent(match.size)}`;
      });

      dialog.querySelector('[data-nx-sg-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-nx-sg-open]');
      if (!btn) return;
      const dialog = document.getElementById(btn.dataset.nxSgOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      bind(dialog);
      dialog.showModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
